import React from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ModalProvider } from "./context/ModalContext";
import { Provider } from "react-redux";
import store from "./redux/store";
import { queryClient } from "./hooks/queryClient";
import { appRouter } from "./appRouter";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ModalProvider>
          <Provider store={store}>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={appRouter} />
            </QueryClientProvider>
          </Provider>
        </ModalProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
